import { render, staticRenderFns } from "./productDetail.pug?vue&type=template&id=1743b305&lang=pug&"
import script from "./productDetail.ts?vue&type=script&lang=ts&"
export * from "./productDetail.ts?vue&type=script&lang=ts&"
import style0 from "./productDetail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports